import {ChangeDetectorRef, Component, OnDestroy} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {Subscription} from "rxjs";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {LoyaltyCardEntityModel} from "../loyalty-card-entity-model.service";
import {LoyaltyCardPeriodUnit, LoyaltyCardProductSelection, LoyaltyCardType} from "../loyalty-card.data";
import {
    ProductLineSearchPageComponent
} from "../../../catalogue/product-line/product-line-search-page/product-line-search-page.component";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {
    ProductLineEditPageComponent
} from "../../../catalogue/product-line/product-line-edit-page/product-line-edit-page.component";
import {
    CompositeProductSearchPageComponent
} from "../../../catalogue/composite-product/composite-product-search-page/composite-product-search-page.component";
import {
    CompositeProductEditPageComponent
} from "../../../catalogue/composite-product/composite-product-edit-page/composite-product-edit-page.component";
import {EntitlementProductData} from "../../../pricing/entitlement/entitlement.data";

@Component({
    selector: "wbo-loyalty-card-edit-page",
    styleUrls: ["./loyalty-card-edit-page.component.scss"],
    templateUrl: "./loyalty-card-edit-page.component.html",
    providers: [(provideEntityModel(LoyaltyCardEntityModel))]
})
export class LoyaltyCardEditPageComponent extends AbstractEditPage implements OnDestroy {
    LoyaltyCardProductSelection = LoyaltyCardProductSelection;
    LoyaltyCardPeriodUnit = LoyaltyCardPeriodUnit;
    LoyaltyCardType = LoyaltyCardType;
    ProductLineSearchPageComponent = ProductLineSearchPageComponent;
    ProductLineEditPageComponent = ProductLineEditPageComponent;
    CompositeProductSearchPageComponent = CompositeProductSearchPageComponent;
    CompositeProductEditPageComponent = CompositeProductEditPageComponent;
    EditMode = EditMode;

    private subscriptions: Subscription = new Subscription();

    constructor(public model: LoyaltyCardEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    soldAsExtraExcludeDefaultChanged(): void {
        if (this.model.data.properties.soldAsExtraExcludeDefault) {
            this.model.data.properties.soldAsExtraIncludeDefault = false;
        }
    }

    soldAsExtraIncludeDefaultChanged(): void {
        if (this.model.data.properties.soldAsExtraIncludeDefault) {
            this.model.data.properties.soldAsExtraExcludeDefault = false;
        }
    }

    discountedItemsChanged(): void {
        if (!this.model.data.discountedItems) {
            this.model.data.freeItems = false;
        }
    }

    afterProductAdded(product: EntitlementProductData): void {
        product.quantity = 1;
    }

    get dealTitlePlaceholder(): string {
        return "'" + (this.model.data.reward.marketingCampaignName || " ") + "'";
    }

    cardTypeChanged() {
        if (this.model.data.cardType === LoyaltyCardType.POINTS) {
            this.model.data.currentCard = undefined;
        }
    }
}
